import React from "react";
import {SvgIcon, SvgIconProps} from "@mui/material";

const BullCallSpreadSvg = (props: any) => (<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" >
        <path d="M1.26667 1V33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M1.2464 18.0225H33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M1 23.9433H8.98293L14.384 18.0225" stroke="#A40C0C" strokeWidth="2"/>
        <path d="M14.384 18.0225L25.0261 5.44064H33" stroke="#089981" strokeWidth="2"/>
    </svg>)


const BullCallSpread: React.FC<SvgIconProps> = React.memo((props) => (
    <SvgIcon {...props}>
        {BullCallSpreadSvg(props)}
    </SvgIcon>
));
export default BullCallSpread

